(function () {
  function initFilterMenus(scope) {
    const root = scope || document;
    const menus = root.querySelectorAll('.filter-menu');

    menus.forEach((menu) => {
      if (menu.dataset.filterMenuInit === 'true') {
        return;
      }

      menu.dataset.filterMenuInit = 'true';

      menu.querySelectorAll('.filter-menu__radio').forEach((radio) => {
        radio.addEventListener('change', () => {
          if (radio.checked && radio.dataset.collectionUrl) {
            window.location.href = radio.dataset.collectionUrl;
          }
        });
      });

      menu.querySelectorAll('.filter-menu__toggle').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
          const nextExpandedState = !isExpanded;
          toggle.setAttribute('aria-expanded', nextExpandedState.toString());
          toggle.classList.toggle('is-active', nextExpandedState);

          const content = findToggleContent(toggle);
          if (!content) {
            return;
          }

          if (nextExpandedState) {
            openContent(content);
          } else {
            closeContent(content);
          }
        });
      });
    });
  }

  function findToggleContent(toggle) {
    const controls = toggle.getAttribute('aria-controls');
    if (controls) {
      const controlled = document.getElementById(controls);
      if (controlled) {
        return controlled;
      }
    }

    const container = toggle.closest('.filter-menu__item');
    if (!container) {
      return null;
    }

    return container.querySelector('.filter-menu__content');
  }

  function openContent(content) {
    content.setAttribute('aria-hidden', 'false');
    const currentHeight = content.scrollHeight;
    content.style.height = currentHeight + 'px';

    const handleTransitionEnd = (event) => {
      if (event.propertyName === 'height') {
        content.style.height = 'auto';
        content.removeEventListener('transitionend', handleTransitionEnd);
      }
    };

    content.addEventListener('transitionend', handleTransitionEnd);
  }

  function closeContent(content) {
    const currentHeight = content.scrollHeight;
    content.style.height = currentHeight + 'px';

    requestAnimationFrame(() => {
      content.setAttribute('aria-hidden', 'true');
      content.style.height = '0px';
    });

    const handleTransitionEnd = (event) => {
      if (event.propertyName === 'height') {
        content.removeEventListener('transitionend', handleTransitionEnd);
      }
    };

    content.addEventListener('transitionend', handleTransitionEnd);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initFilterMenus(document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    initFilterMenus(event.target);
  });
})();
